"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContractStatus;
(function (ContractStatus) {
    ContractStatus["Cancel"] = "Assign seat";
    ContractStatus["Pending"] = "Invite Pending";
    ContractStatus["Active"] = "Seat Active";
})(ContractStatus = exports.ContractStatus || (exports.ContractStatus = {}));
var SeatManagementInviteStatus;
(function (SeatManagementInviteStatus) {
    SeatManagementInviteStatus["PENDING"] = "Pending";
    SeatManagementInviteStatus["ACTIVE"] = "Active";
    SeatManagementInviteStatus["CANCELLED"] = "Cancelled";
})(SeatManagementInviteStatus = exports.SeatManagementInviteStatus || (exports.SeatManagementInviteStatus = {}));
//# sourceMappingURL=index.js.map